import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import BImg from "../../Assetes/Images/burgimg.jpg"
import Modal from 'react-bootstrap/Modal';
import MenuBox from '../Menu/MenuBox';
import FlyBtn from '../Menu/FlyBtn';
import mergn from 'mergn-webapp-sdk'
import { BASE_URL, IMAGE_URL } from '../../Components/client-config';
import ComboMenuBox from '../Menu/ComboMenuBox';
import SelectStoreModal from '../../Components/selectStoreModal';
import { connect, useSelector } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { saveCart } from '../../Redux';
import { useTranslation } from 'react-i18next';

function MenuCard(props: any) {
  const { item } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const [disable, setDisable] = useState(false);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  let cartData = useSelector((state: any) => state.cart.cartData)
  const { t } = useTranslation();

  const handleClick = (data: any) => { }
  
  function handleAdd(item: any) {
    
    if (_.isEmpty(storeSelected)) {
      setSelectStoreModal(true)
  
    }
    
      if (disable) return;
      if (item.menu_item_id > 0) {
        let selectedSize = item.item_size[0];
        let initialPrice = Math.round(((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp));
        let itemPrice = Math.round((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Math.round(selectedSize.discount_price) : Math.round(selectedSize.mrp)
        let discounted_item: any = false;
        let cart: any = cartData;
        if (item.is_active == 1) {
          if ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && (item.item_size[0].order_channel == "all" || item.item_size[0].order_channel == "online")) {
            discounted_item = true;
          } else {
            discounted_item = false;
          }
       
          if (!_.isEmpty(cart)) {
            let found = false;

            cart.forEach((element: any) => {
              if (element["item"]) {
                if (element["item"].menu_item_id == item.menu_item_id) {
                  if (item.item_size[0].size == element.selectedsize.size) {
                    element.quantity = element.quantity + 1;
                    let itemNetPrice = ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && item.item_size[0].order_channel == 'online') ? Math.round(item.item_size[0].discount_price) : Math.round(item.item_size[0].mrp)
                    element.totalItemPrice = itemNetPrice + element.totalItemPrice;
                    found = true
                  }
                }
              }
            });
            if (!found) {
              const itemcart = {
                item: item,
                quantity: 1,
                selectedsize: selectedSize,
                price: Math.round(initialPrice),
                totalItemPrice: Math.round(itemPrice),
                collapseIn: false
              };
              cart.push(itemcart);
            }
          } else {
            const itemcart = {
              item: item,
              quantity: 1,
              selectedsize: selectedSize,
              price: Math.round(initialPrice),
              totalItemPrice: Math.round(itemPrice),
              collapseIn: false
            };
            cart.push(itemcart);
          }

          props.saveCart(cart);
          if (storeSelected) {
            toast.success(`${item.item_name} ${t("ADDED_TO_CART")}`, {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
          }
        } else {
          if (storeSelected) {
            toast.error(t("ITEM_NOT_AVAILABLE"), {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
          }
        }
      } else {
        let initialPrice = Math.round(((item.discount_price || item.discount_price == 0) && (item.order_channel == 'online')) ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price));
        let itemPrice = Math.round((item.discount_price || item.discount_price == 0) && (item.order_channel == 'online')) ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price)
        let discounted_item: any = false;
        let cart: any = cartData;
        if (item.is_active == 1) {
          if ((item.discount_price || item.discount_price == 0) && (item.order_channel == "all" || item.order_channel == "online")) {
            discounted_item = true;
          } else {
            discounted_item = false;
          }
        
          if (!_.isEmpty(cart)) {
            let found = false;
            cart.forEach((element: any) => {
              if (element["combo"]) {
                if (element["combo"].combo_id == item.combo_id) {
                  element.quantity = element.quantity + 1;
                  let itemNetPrice = ((item.discount_price || item.discount_price == 0) && item.order_channel == 'online') ? Math.round(item.discount_price) : Math.round(item.combo_mrp_price)
                  element.totalItemPrice = itemNetPrice + element.totalItemPrice;
                  found = true
                }
              }
            });
            if (!found) {
              const itemcart = {
                combo: item,
                quantity: 1,
                price: Math.round(initialPrice),
                totalItemPrice: Math.round(itemPrice),
                collapseIn: false
              };
              cart.push(itemcart);
            }
          } else {
            const itemcart = {
              combo: item,
              quantity: 1,
              price: Math.round(initialPrice),
              totalItemPrice: Math.round(itemPrice),
              collapseIn: false
            };
            cart.push(itemcart);
          }
          props.saveCart(cart);
          if (storeSelected) {
            toast.success(`${item.combo_name} ${t("ADDED_TO_CART")}`, {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
          }
        } else {
          if (storeSelected) {
            toast.error(t("ITEM_NOT_AVAILABLE"), {
              position: toast.POSITION.TOP_RIGHT,
              hideProgressBar: true,
              autoClose: 3000
            });
          }
        }
      }
    
  };

  const handleEvent = (product: any) => {

    const makeItem = {
      name: product.combo_name ? product.combo_name : product.item_name,
      price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
      category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
      url : {
          page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
          product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
      }
    }

    mergn.recordEvent("Product Click", [
      { eventProperty: 'product-name', value: makeItem.name },
      { eventProperty: 'product-price', value: makeItem.price },
      { eventProperty: 'category-name', value: makeItem.category },
      { eventProperty: 'product-page-url', value: makeItem.url.page },
      { eventProperty: 'product-image-url', value: makeItem.url.product }
    ])

    props.selectedItem(props.item)

  }

  const description =
    item.item_size
      ? item.item_size[0]?.description || "KFC"
      : item.combo_id > 0
        ? item.combo_description || "KFC"
        : "";

  const shortText =
    description.length > 30
      ? `${description.slice(0, 28)}...`
      : description;
  return (
    <div>

      <div className="card menu-card">
        <div className='kfc-box'>
          <span></span>
          <span></span>
          <span></span> 
        </div>
        <div onClick={() => handleEvent(props.item)} className='manu-img-item'>
          <img className='menu-img w-100' onClick={() => handleClick(item)} src={`${IMAGE_URL}${item.menu_item_id ? item.item_size && item.item_size[0].image_url : item.image_url}`} alt={item.menu_item_id ? item?.item_size[0]?.alt_text : item?.combo_name} />

        </div>
        <div  className="card-body p-0">
          <div className='d-flex justify-content-between align-items-center'>
            <h5 className="card-title" onClick={() => handleClick(item)}>{item.menu_item_id ? item.item_name : item.combo_name}</h5>
            <button className='btn-item' onClick={() => props.actions.deletefavourites(item.wish_id, item.menu_item_id ? { product: item.item_name } : { product: item.combo_name })}><i className="ri-heart-fill clr-red"></i></button>

          </div>
          <p
            className="card-text"
            title={description}
            onClick={() => handleClick(item)}
          >
            {shortText}
          </p>

          
        </div>
      
      </div>

      <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />
      
     
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <div className='modal-design'>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Modal.Header className='p-0 border-0' closeButton>
        </Modal.Header>
        <MenuBox />
      </Modal>

      
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    saveCart: function (cart: any[]) {
      dispatch(saveCart(cart));
    }
  };
};

export default connect(null, mapDispatchToProps)(MenuCard);
